const EmailLink = ({ mail, className, children }) => {
  return (
    <a
      href={`mailto:${mail}`}
      className={`text-2xl md:text-4.5xl flex items-center mt-1 md:mb-1 ${className}`}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        className="w-8 h-8 mr-2 md:w-12 md:h-12"
      >
        <path d="M35.5975 0H4.40248C1.97108 0 0 1.9705 0 4.40118V35.5988C0 38.0295 1.97108 40 4.40248 40H35.5975C38.0289 40 40 38.0295 40 35.5988V4.40118C40 1.9705 38.0289 0 35.5975 0ZM35.5975 2.35988C35.751 2.35988 35.8926 2.38348 36.0342 2.40708L19.8761 18.3363L3.97757 2.40708C4.11921 2.38348 4.26084 2.35988 4.40248 2.35988H35.5975ZM37.6394 35.5988C37.6394 36.7316 36.7188 37.6401 35.5975 37.6401H4.40248C3.2694 37.6401 2.36058 36.7198 2.36058 35.5988V4.40118C2.36058 4.31858 2.37238 4.23599 2.38418 4.14159L19.0263 20.826C19.2623 21.0619 19.5574 21.1681 19.8643 21.1681C20.1711 21.1681 20.4662 21.0501 20.6905 20.826L37.6158 4.16519C37.6158 4.24779 37.6394 4.31858 37.6394 4.40118V35.5988Z" />
      </svg>
      <span className="mb-1 md:mb-2">{children}</span>
    </a>
  );
};

export default EmailLink;
